import { defineComponent as _defineComponent } from 'vue';
import { ChevronLeftIcon, ChevronRightIcon } from "lucide-vue-next";
import { computed } from "vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'PaginationControls',
    props: {
        currentPage: { type: Number, required: true },
        totalItems: { type: Number, required: true },
        itemsPerPage: { type: Number, required: true },
        maxVisiblePages: { type: Number, required: false, default: 5 }
    },
    emits: ["changePage"],
    setup(__props, { expose: __expose, emit: __emit }) {
        __expose();
        const props = __props;
        const emit = __emit;
        const totalPages = computed(() => Math.ceil(props.totalItems / props.itemsPerPage));
        const startPage = computed(() => {
            const half = Math.floor(props.maxVisiblePages / 2);
            let start = props.currentPage - half;
            const end = start + props.maxVisiblePages - 1;
            if (end > totalPages.value) {
                start = totalPages.value - props.maxVisiblePages + 1;
            }
            return Math.max(1, start);
        });
        const endPage = computed(() => {
            return Math.min(totalPages.value, startPage.value + props.maxVisiblePages - 1);
        });
        const pagesToShow = computed(() => {
            const pages = [];
            for (let i = startPage.value; i <= endPage.value; i++) {
                pages.push(i);
            }
            return pages;
        });
        const goToPage = (page) => {
            if (page >= 1 && page <= totalPages.value && page !== props.currentPage) {
                emit("changePage", page);
            }
        };
        const __returned__ = { props, emit, totalPages, startPage, endPage, pagesToShow, goToPage, get ChevronLeftIcon() { return ChevronLeftIcon; }, get ChevronRightIcon() { return ChevronRightIcon; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
